// removed by extract-text-webpack-plugin
module.exports = {"separator":"Separator__separator___2wJIW","-no-margin":"Separator__-no-margin___38fRM"};


//////////////////
// WEBPACK FOOTER
// ./application/js/components/Separator.css
// module id = 521
// module chunks = 0